const COOKIE_NAME = "nw4_iti_initial_country";
const COOKIE_MAX_AGE_DAYS = 30;
const IPAPI_URL = "https://ipapi.co/json";

const readCookie = (name) => {
    if (typeof document === "undefined") {
        return null;
    }

    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
};

const writeCookie = (name, value, maxAgeDays = COOKIE_MAX_AGE_DAYS) => {
    if (typeof document === "undefined") {
        return;
    }

    const maxAgeSeconds = maxAgeDays * 24 * 60 * 60;
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
};

const normalizeIso2 = (value) => {
    const normalized = String(value || "").trim().toLowerCase();
    return /^[a-z]{2}$/.test(normalized) ? normalized : null;
};

/**
 * Resolves the initial phone country via cookie cache or ipapi lookup.
 * Rejects on failure so intl-tel-input falls back to the globe state.
 */
export const initialCountryLookup = async () => {
    const cachedCountry = normalizeIso2(readCookie(COOKIE_NAME));
    if (cachedCountry) {
        return cachedCountry;
    }

    const response = await fetch(IPAPI_URL);
    if (!response.ok) {
        throw new Error(`ipapi lookup failed with status ${response.status}`);
    }

    const data = await response.json();
    const resolvedCountry = normalizeIso2(data?.country_code);
    if (!resolvedCountry) {
        throw new Error("ipapi lookup returned no country_code");
    }

    writeCookie(COOKIE_NAME, resolvedCountry);
    return resolvedCountry;
};
